// extracted by mini-css-extract-plugin
export default {"container":"AboutHeader_container__o4EYi","headerImg":"AboutHeader_headerImg__iLf7+","text1":"AboutHeader_text1__LvnJG","text2":"AboutHeader_text2__Rz1wV"};